import React from 'react'
import './Ministries.css'
import '../../../App.css'
import '../SubLinks.css'
import MinistryLinks from '../MinistryLinks';
import { Link } from 'react-router-dom'

function YouthGroup() {
    return (
        <div>
            <div className='hero-container youth half'>
                <h1></h1>
            </div>
        <div className='main-grid-container'>
          <div className='main-grid-item'>
        <MinistryLinks/>
        </div>
        <div className='main-grid-item'>
        <div className='main with-sublinks'>
                <h1>Youth Group</h1>
                <div className='blockquote-container'>
                    <blockquote> Him we proclaim, admonishing every man and teaching every man with all wisdom, so that we may present every man complete in Christ. For this purpose I also labor, striving according to His working, which He works in me in power.
                        <cite> - Colossians 1:28-29</cite>
                    </blockquote>
                    </div> 
                <p>
                    The goal of our youth group gatherings at Grace Community Fellowship is to assist parents in teaching our young people to know and love God, be fruitful for His glory and pursue the good of others. We work to help them in their transition into adulthood by deepening their love and knowledge of God and helping them develop a biblical worldview.
                </p>
                <p>
                It is our prayer that as we train young people to think biblically about all of life, they will come to saving faith and grow in holiness and service to the Lord.  
                </p>
                <h3>Discipleship Opportunities Include:</h3>
                    <ul className='ul-ministries'>
                    <li>Bible Studies</li>
                    <li>Personal Discipleship & Counseling</li>
                    <li>Summer & Winter Camps</li>
                    <li>Community Evangelism</li>
                    <li>Short-Term Missions Trips</li>
                    </ul>
                    <p>
                If you are interested in learning more about our Youth Group Ministry please <Link to='/contact-us' className='p-link'>contact us</Link>.
                </p>
            </div>
        </div>
        </div>
        </div>
    )
}

export default YouthGroup
